export default "__VITE_ASSET__NOeELrWy__"